import {flokAxios} from "."
import {AttendeeLandingWebsiteModel} from "../models/retreat"

export function getSite(siteId: number) {
  return flokAxios<{website: AttendeeLandingWebsiteModel}>({
    url: `/v1.0/websites/${siteId}`,
    method: "GET",
  })
}
